import styled from '@emotion/styled';
import {
  LoadingOverlay,
  tokens,
  Typography,
  useSingletonMobileMediaQuery,
} from '@sunrun/experience-ui-components';
import { useFeatureFlagEnabled } from '@sunrun/sales-experience-shared/react-feature-flags';
import { isSunrunManaged } from '@sunrun/sales-experience-shared';
import { DashboardWidgetContainer } from 'components/atoms/DashboardWidgetContainer';
import {
  DashboardLayout,
  DashboardLayoutItem,
} from 'components/molecules/DashboardLayout';
// eslint-disable-next-line import/no-restricted-paths
import { ErrorNotFound } from 'components/pages/ErrorNotFound';
import { StreamsWidget } from 'components/organisms/StreamsWidget';
import { UserGuidesTutorialsWidget } from 'components/organisms/UserGuidesTutorialsWidget';
import { RunXLearningLayoutItem } from 'components/organisms/TrainingsWidget';
import {
  PlaybookWidget,
  useShowPlaybook,
} from 'components/organisms/PlaybookWidget';
import { FEATURE_FLAGS } from 'constants/FeatureFlags';
import { useFlagsmith, useFlagsmithLoading } from 'hooks/useFlagsmith';
import { useUserProfile } from 'providers/UserProfile';

const Academy = () => {
  const { userProfile } = useUserProfile();
  const flagsmith = useFlagsmith();
  const flagsmithLoading = useFlagsmithLoading();
  const academyPageEnabled = useFeatureFlagEnabled(FEATURE_FLAGS.ACADEMY_PAGE);
  const trainingsEnabled = useFeatureFlagEnabled(FEATURE_FLAGS.RUN_X_TRAININGS);
  const isMobile = useSingletonMobileMediaQuery();
  const showPlaybook = useShowPlaybook();

  const contactId = userProfile?.contactId;
  const flagsReady =
    Boolean(contactId) &&
    flagsmith.identity === contactId &&
    !flagsmithLoading?.isFetching;

  if (!flagsReady || academyPageEnabled === undefined) {
    return <LoadingOverlay message="Loading..." />;
  }

  if (!academyPageEnabled) {
    return <ErrorNotFound />;
  }

  const isSRM = userProfile ? isSunrunManaged(userProfile) : false;
  const showTrainings = isSRM && trainingsEnabled;

  return (
    <Container>
      <Typography size={28} color={tokens.BRAND_HERO_BLUE}>
        Academy
      </Typography>
      <DashboardLayout>
        {showTrainings && <RunXLearningLayoutItem isMobile={isMobile} />}
        {showPlaybook && (
          <DashboardLayoutItem blockColumns={1} blockRows={6}>
            <DashboardWidgetContainer header="PERSPECTIVE, PROCESS, PRACTICE">
              <PlaybookWidget />
            </DashboardWidgetContainer>
          </DashboardLayoutItem>
        )}
        <DashboardLayoutItem blockColumns={1} blockRows={6}>
          <DashboardWidgetContainer
            header="User Guides & Tutorials"
            navigateTo={() => {
              window.open('https://current.sunrun.com/', '_blank');
            }}>
            <UserGuidesTutorialsWidget />
          </DashboardWidgetContainer>
        </DashboardLayoutItem>
        <DashboardLayoutItem blockColumns={1} blockRows={7}>
          <DashboardWidgetContainer header="Stream & Training">
            <StreamsWidget />
          </DashboardWidgetContainer>
        </DashboardLayoutItem>
      </DashboardLayout>
    </Container>
  );
};

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export { Academy };
